import React, { useState } from 'react';
import { Zap, TrendingDown, BarChart3, Shield } from 'lucide-react';
import { WaveBackground } from './components/WaveBackground';
import { EnergyChart } from './components/EnergyChart';
import { AIProcessTimeline } from './components/AIProcessTimeline';
import { ContactPopup } from './components/ContactPopup';
export function App() {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);
  // Enhanced smooth scrolling function
  const scrollToChart = () => {
    const chartElement = document.getElementById('energy-chart');
    if (chartElement) {
      // Get the target position
      const targetPosition = chartElement.getBoundingClientRect().top + window.pageYOffset;
      // Current position
      const startPosition = window.pageYOffset;
      // Distance to scroll
      const distance = targetPosition - startPosition;
      // Duration in milliseconds
      const duration = 800;
      // Start time
      let startTime = null;
      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        // Easing function for smoother animation
        const easeInOutQuad = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        window.scrollTo(0, startPosition + distance * easeInOutQuad(progress));
        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        }
      }
      requestAnimationFrame(animation);
    }
  };
  const handleContactSubmit = (name: string, email: string) => {
    // Here you would typically send this data to your backend
    console.log('Contact form submitted:', {
      name,
      email
    });
    // You could also show a success message to the user
    alert(`Gracias ${name}, nos pondremos en contacto contigo pronto.`);
  };
  return <div className="min-h-screen w-full bg-white text-black font-mono" data-id="element-0">
      <WaveBackground data-id="element-1" />
      {/* Header */}
      <header className="bg-white border-b border-gray-300 p-4 relative z-10" data-id="element-2">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-3">
          <div className="text-xl font-bold tracking-tight !font-audiowide" data-id="element-4">
            VECTREI
          </div>
          <button onClick={() => setIsContactPopupOpen(true)} className="relative px-6 py-2 bg-black text-white hover:bg-gray-800 transition-colors corner-accent" data-id="element-5">
            EMPEZAR
          </button>
        </div>
      </header>
      {/* Hero Section */}
      <main className="max-w-7xl mx-auto px-4 py-16 relative z-10" data-id="element-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-7">
          <div className="relative p-8 bg-white corner-accent" data-id="element-8">
            <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-9">
              OPTIMIZAMOS EL MOMENTO MÁS IDÓNEO PARA OPERAR ACTIVOS DE GENERACIÓN Y ALMACENAMIENTO
            </h1>
            <p className="text-lg mb-8 text-gray-700" data-id="element-10">
              Nuestro algoritmo es el mas certero en proyectar los precios de
              energia en el mercado spot
            </p>
            <div className="flex gap-4" data-id="element-11">
              <button onClick={() => setIsContactPopupOpen(true)} className="relative px-8 py-3 bg-black text-white hover:bg-gray-800 transition-colors corner-accent" data-id="element-12">
                INICIAR PRUEBA
              </button>
              <button onClick={scrollToChart} className="relative px-8 py-3 bg-white text-black hover:bg-gray-100 transition-colors corner-accent" data-id="element-13">
                VER DEMO
              </button>
            </div>
          </div>
          {/* Metrics Panel */}
          <div className="relative p-8 bg-gray-50 corner-accent" data-id="element-14">
            <div className="text-xs uppercase tracking-wider mb-6 text-gray-600" data-id="element-15">
              MÉTRICAS EN VIVO
            </div>
            <div className="space-y-6" data-id="element-16">
              <div data-id="element-17">
                <div className="flex justify-between items-baseline mb-2" data-id="element-18">
                  <span className="text-sm" data-id="element-19">
                    PERFORMANCE DE NUESTRA PROYECCIÓN
                  </span>
                  <span className="text-3xl font-bold text-green-600" data-id="element-20">
                    -38%
                  </span>
                </div>
                <div className="h-2 bg-gray-300" data-id="element-21">
                  <div className="h-full bg-green-600 w-[38%]" data-id="element-22"></div>
                </div>
              </div>
              <div data-id="element-23">
                <div className="flex justify-between items-baseline mb-2" data-id="element-24">
                  <span className="text-sm" data-id="element-25">VARIABLES PROCESADAS</span>
                  <span className="text-3xl font-bold" data-id="element-26">19.922</span>
                </div>
                <div className="h-2 bg-gray-300" data-id="element-27">
                  <div className="h-full bg-black w-[67%]" data-id="element-28"></div>
                </div>
              </div>
              <div data-id="element-29">
                <div className="flex justify-between items-baseline mb-2" data-id="element-30">
                  <span className="text-sm" data-id="element-31">ENERGÍA OPTIMIZADA (MWh)</span>
                  <span className="text-3xl font-bold" data-id="element-32">7.764.363</span>
                </div>
                <div className="h-2 bg-gray-300" data-id="element-33">
                  <div className="h-full bg-black w-[82%]" data-id="element-34"></div>
                </div>
              </div>
              <div data-id="element-35">
                <div className="flex justify-between items-baseline mb-2" data-id="element-36">
                  <span className="text-sm" data-id="element-37">INGRESOS GENERADOS (USD)</span>
                  <span className="text-3xl font-bold" data-id="element-38">$146.638.864</span>
                </div>
                <div className="h-2 bg-gray-300" data-id="element-39">
                  <div className="h-full bg-black w-[75%]" data-id="element-40"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-16" data-id="element-41">
          <div className="relative p-6 bg-white hover:bg-gray-50 transition-colors group corner-accent" data-id="element-42">
            <Zap className="w-8 h-8 mb-4" data-id="element-43" />
            <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-44">
              TIEMPO REAL
            </div>
            <h3 className="text-lg font-bold mb-2" data-id="element-45">OPTIMIZACIÓN INSTANTÁNEA</h3>
            <p className="text-sm" data-id="element-46">
              Monitoreo y ajuste de patrones del mercado eléctrico considerando
              variables de generación y demanda.
            </p>
          </div>
          <div className="relative p-6 bg-white hover:bg-gray-50 transition-colors group corner-accent" data-id="element-47">
            <TrendingDown className="w-8 h-8 mb-4" data-id="element-48" />
            <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-49">
              ANALÍTICA
            </div>
            <h3 className="text-lg font-bold mb-2" data-id="element-50">MODELOS PREDICTIVOS</h3>
            <p className="text-sm" data-id="element-51">
              Pronósticos impulsados por IA para anticipar y prevenir los
              patrones del mercado eléctrico.
            </p>
          </div>
          <div className="relative p-6 bg-white hover:bg-gray-50 transition-colors group corner-accent" data-id="element-52">
            <BarChart3 className="w-8 h-8 mb-4" data-id="element-53" />
            <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-54">
              REPORTES
            </div>
            <h3 className="text-lg font-bold mb-2" data-id="element-55">INSIGHTS DETALLADOS</h3>
            <p className="text-sm" data-id="element-56">Módulos completos con datos accionables.</p>
          </div>
          <div className="relative p-6 bg-white hover:bg-gray-50 transition-colors group corner-accent" data-id="element-57">
            <Shield className="w-8 h-8 mb-4" data-id="element-58" />
            <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-59">
              CONFIABILIDAD
            </div>
            <h3 className="text-lg font-bold mb-2" data-id="element-60">NIVEL EMPRESARIAL</h3>
            <p className="text-sm" data-id="element-61">
              Certeza de las proyecciones modeladas gracias a nuestro algoritmo
              altamente entrenado.
            </p>
          </div>
        </div>
        {/* Energy Chart Section */}
        <div id="energy-chart" data-id="element-62">
          {/* AI Process Timeline */}
          <AIProcessTimeline data-id="element-63" />
          <EnergyChart data-id="element-64" />
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-white border-t border-gray-300 p-4 mt-16 relative z-10" data-id="element-65">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-66">
          <div className="text-xl font-bold tracking-tight !font-audiowide" data-id="element-67">
            VECTREI
          </div>
          <p className="text-sm text-gray-600 text-center md:text-right" data-id="element-68">
            © 2025 VECTREI. TODOS LOS DERECHOS RESERVADOS.
          </p>
        </div>
      </footer>
      {/* Contact Popup */}
      <ContactPopup isOpen={isContactPopupOpen} onClose={() => setIsContactPopupOpen(false)} onSubmit={handleContactSubmit} data-id="element-69" />
    </div>;
}